import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Grid,
    CircularProgress,
    Button,
    Box,
    InputLabel,
    NativeSelect,
} from "@mui/material";
import { useSnackbar } from "notistack";
import http, { buildFormData, ROUTES } from "src/utils/httpHelper";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm, FormProvider, useFormContext } from "react-hook-form";
import * as Yup from "yup";
import i18n from "src/i18n/i18n";
import PageHeader from "src/components/PageHeader";
import Card from "@mui/material/Card";
import ListAltIcon from '@mui/icons-material/ListAlt';

export function InvoicerXmlToList() {
    const { t }: { t: any } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const formRules = Yup.object().shape({
      xml: Yup.mixed()
        .required(i18n.t("VALIDATION.REQUIRED")),
      combine: Yup.number()
        .min(0)
        .max(2)
        .required(i18n.t("VALIDATION.REQUIRED")),
    });

    const initialValues = {
      xml: "",
      combine: "0",
    };

    const { handleSubmit, formState: { errors, isSubmitting, isValid }, control, setValue, reset } = useForm({
      mode: 'onTouched',
      resolver: yupResolver(formRules),
      defaultValues: initialValues
    });

    return (
      <Fragment>
        <PageHeader
          heading={t(("INVOICER-XML-TO-LIST.HEADING").toUpperCase())}
          subheading={t(("INVOICER-XML-TO-LIST.SUBHEADING").toUpperCase())}
          Icon={ListAltIcon}
        />

        <Grid
          sx={{
            px: 4,
            pb: 4
          }}
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={4}
        >
          <Grid item xs={12} md={12}
            sx={{
              pl: 4,
              pt: 4,
            }}
          >
            <Card>
              <Box p={2}>
                <Grid container display={'flex'} justifyContent={'space-between'}>
                  <Grid item xs={12} md={12}>
                    <form id="myForm" noValidate onSubmit={handleSubmit(async (values) => {
                      const formData = new FormData();
                      buildFormData(formData, {...values});
                      let inputFile = (document.getElementById('xml') as HTMLInputElement).files[0];
                      if (inputFile) {
                        formData.set("xml", inputFile);
                      } else {
                        formData.delete("xml");
                      }
                      await http.request({
                        method: 'post',
                        url: '/api/invoicer/get-list-from-sap-xml',
                        data: formData,
                      })
                      .then((response) => {
                        let responseHtml = response.data;
                        var myWindow = window.open("", "_blank");
                        //Open HTML in new tab
                        myWindow.document.write(responseHtml);
                        enqueueSnackbar(response.data.message, { variant: 'success' });
                      })
                      .catch((error) => {
                        console.error(error);
                        enqueueSnackbar(error.message, { variant: 'error' });
                      });
                    })}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                          <InputLabel htmlFor="xml">XML</InputLabel>
                          <Controller
                            name="xml"
                            control={control}
                            render={({ field }) => (
                              <input
                                accept="text/xml"
                                id="xml"
                                type="file"
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={12} mt={2}>
                          <InputLabel variant="standard" htmlFor="select-combine">
                            {t("FIELDS.COMBINE_ITEMS")}
                          </InputLabel>
                          <NativeSelect
                            fullWidth
                            inputProps={{
                              name: 'combine',
                              id: 'select-combine',
                            }}
                            onChange={(event) => {
                              setValue('combine', event.target.value);
                            }}
                            >
                              <option value={0}>No combinar</option>
                              <option value={1}>Combinar por clave del SAT (ClaveProdServ)</option>
                              <option value={2}>Combinar por clave del SAP (NoIdentificacion)</option>
                          </NativeSelect>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3} mt={1}>
                        <Grid item xs={12} md={12} display="flex" justifyContent="flex-end">
                          <Button
                            sx={{
                              ml: 2
                            }}
                            type="submit"
                            startIcon={
                              isSubmitting ? <CircularProgress size="1rem" /> : null
                            }
                            disabled={(() => {
                              return isSubmitting || !isValid
                          })()}
                            variant="contained"
                          >
                            {t("INVOICER-XML-TO-LIST.CREATE")}
                          </Button>
                        </Grid>
                      </Grid>
                    </form>
                  </Grid>
                </Grid>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Fragment>
    )
}